import { authStateSelectors, useAuthState } from "../state/AuthState";

export const usePermission = () => {
  const user = useAuthState(authStateSelectors.user);

  return {
    isSuperAdmin: !!user?.roles?.some(role => role.name === "Think12 Admin"),
  };
};
